import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { remove } from 'assets/icons';
import { ITepEntryPass } from 'types/tep';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { selectedLeasesSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

interface IActionsProps {
  entryPass: ITepEntryPass;
}

export const Actions: FC<IActionsProps> = ({ entryPass }) => {
  const dispatch = useDispatch();

  const leases = useSelector(selectedLeasesSelector);

  const onRemove = () => {
    const updatedLeases = leases.filter(({ id }) => id !== entryPass.id);

    updatedLeases.length ? dispatch(leasesActions.select({ leases: updatedLeases })) : dispatch(leasesActions.close());
  };

  return (
    <div className={styles.actions}>
      <SvgWrapper width={24} height={24} details={remove} onClick={onRemove} />
    </div>
  );
};
